export interface KustomerConfig {
  apiKey: string
  brandId: string
  assistantId: string
  scheduleId?: string
  lang?: string
  liveHelpText: string
}

export function getConfigForLocale(locale: string): KustomerConfig | undefined {
  if (!kustomerConfigs.hasOwnProperty(locale))
    return undefined

  const config = kustomerConfigs[locale]
  config.lang = locale.split('-')[0]
  return config
}

const kustomerConfigs: { [key: string]: KustomerConfig } = {
  'en-US-not-enabled': {
    apiKey: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6IjYwMzk0ZDE5MTRlZTJjMDA4ZTNhNTFjMyIsInVzZXIiOiI2MDM5NGQxODZkZTNjZjY5MWI4NWJkYzYiLCJvcmciOiI1ZWRhOWZkMTM4Y2U3ZjAwMTRlYmNkZjgiLCJvcmdOYW1lIjoieW91bmdsaXZpbmciLCJ1c2VyVHlwZSI6Im1hY2hpbmUiLCJwb2QiOiJwcm9kMSIsInJvbGVzIjpbIm9yZy50cmFja2luZyJdLCJhdWQiOiJ1cm46Y29uc3VtZXIiLCJpc3MiOiJ1cm46YXBpIiwic3ViIjoiNjAzOTRkMTg2ZGUzY2Y2OTFiODViZGM2In0.TqQIfBv1gyeY_tgjeobq1HknE7Aaah1MdW6eSq9Ii6M',
    brandId: '5eda9fd45679130013f3d423',
    assistantId: '602c98d2c587c00019a424f7',
    scheduleId: '601edb3e8ebda0001a9547c6',
    liveHelpText: 'For Live Help, please click the [chat-icon] icon in the lower right corner'
  },
  'es-US-not-enabled': {
    apiKey: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6IjYwMzk0ZDE5MTRlZTJjMDA4ZTNhNTFjMyIsInVzZXIiOiI2MDM5NGQxODZkZTNjZjY5MWI4NWJkYzYiLCJvcmciOiI1ZWRhOWZkMTM4Y2U3ZjAwMTRlYmNkZjgiLCJvcmdOYW1lIjoieW91bmdsaXZpbmciLCJ1c2VyVHlwZSI6Im1hY2hpbmUiLCJwb2QiOiJwcm9kMSIsInJvbGVzIjpbIm9yZy50cmFja2luZyJdLCJhdWQiOiJ1cm46Y29uc3VtZXIiLCJpc3MiOiJ1cm46YXBpIiwic3ViIjoiNjAzOTRkMTg2ZGUzY2Y2OTFiODViZGM2In0.TqQIfBv1gyeY_tgjeobq1HknE7Aaah1MdW6eSq9Ii6M',
    brandId: '5eda9fd45679130013f3d423',
    assistantId: '602c98d2c587c00019a424f7',
    scheduleId: '601edb3e8ebda0001a9547c6',
    liveHelpText: 'Para obtener Ayuda en Vivo, favor de hacer clic en el [chat-icon] icono de la parte inferior derecha'
  },
  'en-CA-not-enabled': {
    apiKey: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6IjYwMzk0ZDhiZTA4ZmE4MDA4ZTk1YTk3MCIsInVzZXIiOiI2MDM5NGQ4YTZjNDZmNDRkZmYxNWY0MDMiLCJvcmciOiI1ZWRhOWZkMTM4Y2U3ZjAwMTRlYmNkZjgiLCJvcmdOYW1lIjoieW91bmdsaXZpbmciLCJ1c2VyVHlwZSI6Im1hY2hpbmUiLCJwb2QiOiJwcm9kMSIsInJvbGVzIjpbIm9yZy50cmFja2luZyJdLCJhdWQiOiJ1cm46Y29uc3VtZXIiLCJpc3MiOiJ1cm46YXBpIiwic3ViIjoiNjAzOTRkOGE2YzQ2ZjQ0ZGZmMTVmNDAzIn0.r18AKTXe8MGpoluqorhFMYedFy_-FivBhgHQZQgUhX0',
    brandId: '5eda9fd45679130013f3d423',
    assistantId: '602c68d2669d8c001a49ded0',
    scheduleId: '601edbbe8ebda0001a9547fd',
    liveHelpText: 'For Live Help, please click the [chat-icon] icon in the lower right corner'
  },
  'fr-CA-not-enabled': {
    apiKey: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6IjYwMzk0ZDhiZTA4ZmE4MDA4ZTk1YTk3MCIsInVzZXIiOiI2MDM5NGQ4YTZjNDZmNDRkZmYxNWY0MDMiLCJvcmciOiI1ZWRhOWZkMTM4Y2U3ZjAwMTRlYmNkZjgiLCJvcmdOYW1lIjoieW91bmdsaXZpbmciLCJ1c2VyVHlwZSI6Im1hY2hpbmUiLCJwb2QiOiJwcm9kMSIsInJvbGVzIjpbIm9yZy50cmFja2luZyJdLCJhdWQiOiJ1cm46Y29uc3VtZXIiLCJpc3MiOiJ1cm46YXBpIiwic3ViIjoiNjAzOTRkOGE2YzQ2ZjQ0ZGZmMTVmNDAzIn0.r18AKTXe8MGpoluqorhFMYedFy_-FivBhgHQZQgUhX0',
    brandId: '5eda9fd45679130013f3d423',
    assistantId: '602c68d2669d8c001a49ded0',
    scheduleId: '601edbbe8ebda0001a9547fd',
    liveHelpText: "Pour l'aide en direct, veuillez cliquer sur [chat-icon] l'icône en bas à droite"
  },
}